import { gql } from '@apollo/client';

/**
 * The OTP failures tab: why sign-in codes were not sent, read from the API's
 * OtpSendLog. What each outcome means is in the backend's
 * docs/OTP_FAILURES_REPORT.md; the explanations themselves come from the API.
 */

export const REPORT_OTP_FAILURES = gql`
  query reportOtpFailures($range: ReportRangeInput!, $channel: OtpChannel) {
    reportOtpFailures(range: $range, channel: $channel) {
      totals {
        attempts
        sent
        twilioErrors
        blocked
        test
        failureRate
        destinations
        destinationsNeverSent
      }
      reasons {
        outcome
        category
        side
        twilioCode
        label
        explanation
        memberSaw
        action
        docsUrl
        attempts
        destinations
        sms
        email
        lastAt
      }
      periods {
        period
        attempts
        sent
        twilioErrors
        blocked
      }
      countries {
        dialCode
        country
        name
        attempts
        sent
        twilioErrors
        blocked
        topFailure
      }
    }
  }
`;

export const REPORT_OTP_ATTEMPTS = gql`
  query reportOtpAttempts($range: ReportRangeInput!, $filter: OtpAttemptFilterInput, $page: ReportPageInput) {
    reportOtpAttempts(range: $range, filter: $filter, page: $page) {
      total
      attempts {
        id
        createdAt
        channel
        destination
        outcome
        category
        label
        detail
        countryName
        ipAddress
        member {
          id
          firstName
          lastName
          username
          isDeleted
        }
      }
    }
  }
`;
